// extracted by mini-css-extract-plugin
export var page = "content-module--page--p39Pn";
export var pageInner = "content-module--pageInner--56XaK";
export var extra = "content-module--extra--rOlkZ";